import { getNewToken, logout } from "../app/modules/Auth/_redux/authCrud";
import * as authReducer from "../app/modules/Auth/_redux/authRedux";



export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();
      if (authToken && !config.url.includes("GetTokenByRefreshToken")) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }
      if (config.url.includes("ChangePassword")) {
        const tempToken = JSON.parse(sessionStorage.accessToken);
        config.headers.Authorization = `Bearer ${tempToken}`;
      }
      if (
        config.url.includes("CreateDetailByMe") ||
        config.url.includes("UpdateDetailByMe") ||
        config.url.includes("UploadFileByMe") ||
        config.url.includes("UpdateUserByMe") ||
        config.url.includes("Downloadfile")
      ) {
        const tempToken = JSON.parse(sessionStorage.accessToken);
        config.headers.Authorization = `Bearer ${tempToken}`;
      }

      config.timeout = 240000;
      return config;
    },
    err => Promise.reject(err)
  );

  axios.interceptors.response.use(response => {
    return response;
  }, error => {
    //console.log("setupAxios Error");
    //console.log(JSON.stringify(error));
    // if (error.message.includes("timeout of ")) {
    //   return Promise.reject(error);
    // }
    // if (error.message.includes("Network Error")) {
    //   // return Promise.reject(error);
    // }
    if (error.response.status && error.response.status === 401) {//&& tryGetNewTokenCount === 0
      const {
        auth: { refreshToken, user }
      } = store.getState();


      return getNewToken(user.username, refreshToken) // Endpoint to request new token
        .then((res) => {
          sessionStorage.setItem('authUser', JSON.stringify(res.data.data.user));
          sessionStorage.setItem('authUserMenu', JSON.stringify(res.data.data.menu));
          localStorage.setItem('authToken', JSON.stringify(res.data.data.accessToken));
          localStorage.setItem('refreshToken', JSON.stringify(res.data.data.refreshToken));

          store.dispatch(authReducer.actions.tokenRefreshed(
            res.data.data.accessToken,
            res.data.data.refreshToken,
            res.data.data.user,
            res.data.data.menu
          ));

          error.response.config.headers.Authorization = res.data.data.accessToken; // Attach the new token to the headers
          error.response.config.timeout = 240000;
          return axios(error.response.config);
        })
        .catch((err) => {
          // logout(user.id)
          //   .then((res) => {
          window.localStorage.clear();
          window.sessionStorage.clear();
          window.location.href = "/#/auth/login";
          window.location.reload();
          return Promise.reject(err);
          // })
          // .catch((err2) => {
          //   // window.localStorage.clear();
          //   // window.location.replace("/auth/login");
          //   return Promise.reject(err2);
          // });

        });

      // window.localStorage.clear();
      // window.location.replace("/auth/login");
      // return Promise.reject(error);

      // return new Promise((resolve, reject) => {
      //   refreshToken(axios, error.config)
      //     .then((result) => {
      //       resolve(result);
      //     })
      //     .catch((err) => {
      //       window.localStorage.clear();
      //       window.location.replace("/auth/login");
      //       reject(err);
      //     });
      // });


    }
    // else if (error.response.status && error.response.status === 401 && tryGetNewTokenCount > 0) {
    //   window.localStorage.clear();
    //   window.location.replace("/auth/login");
    // }

    return Promise.reject(error);

  });



  // const refreshToken = (axios, config) => {
  //   const {
  //     auth: { refreshToken, user }
  //   } = store.getState();


  //   return new Promise((resolve, reject) => {

  //     getNewToken(user.username, refreshToken) // Endpoint to request new token
  //       .then((res) => {
  //         console.log("RefreshTokenRes")
  //         console.log(res)
  //         sessionStorage.setItem('authUser', JSON.stringify(res.data.data.user));
  //         sessionStorage.setItem('authUserMenu', JSON.stringify(res.data.data.menu));
  //         localStorage.setItem('authToken', JSON.stringify(res.data.data.accessToken));
  //         localStorage.setItem('refreshToken', JSON.stringify(res.data.data.refreshToken));

  //         store.commit('authToken', res.data.data.accessToken)
  //         store.commit('refreshToken', res.data.data.refreshToken);


  //         config.headers.Authorization = res.data.data.accessToken; // Attach the new token to the headers
  //         config.timeout = 60000;
  //         axios
  //           .request(config) // Repeat the initial request
  //           .then((result) => {
  //             return resolve(result);
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //             return reject(err);
  //           });
  //       })
  //       .catch((err) => {
  //         window.localStorage.clear();
  //         window.location.replace("/auth/login");
  //         return reject(err);
  //       });
  //   });
  // };


  //   function refreshToken(store) {
  //     const {
  //       auth: { refreshToken, user }
  //     } = store.getState();

  //     store.commit('auth/setRefreshingState', true);
  //     const refreshingCall = refreshInstance.get('get token').then(({ data: { token } }) => {
  //       store.commit('auth/setToken', token)
  //       store.commit('auth/setRefreshingState', false);
  //       store.commit('auth/setRefreshingCall', undefined);
  //       return Promise.resolve(true);
  //     });

  //     store.commit('auth/setRefreshingCall', refreshingCall);
  //     return refreshingCall;
  //   }
}
